import { Component, OnInit,ElementRef, Renderer2, inject } from '@angular/core';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-da-addressreport',
  templateUrl: './da-addressreport.component.html',
  styleUrls: ['./da-addressreport.component.scss']
})
export class DaAddressreportComponent implements OnInit {
  private document = inject(DOCUMENT)
  spinner: boolean;
  customers: any = [];
  dtOptions: any = {};
  tableshow: boolean = false;
  regob:any;
  dashboardcarddata: any;
  printPage() {
      window.print();
  }

constructor( private el: ElementRef,
  private renderer: Renderer2,
            public ApiService: ApiServiceService,
            private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.getdata();
    this.showSpinner();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [[0, 'asc']],
      // dom: 'lBfrtip',
      //   buttons: ['print'],
    };
   // this.addPrintStyles();
    // this.applyStylesToDOMElement();
  }
  
  
  getdata() {
    this.spinner = true;
    this.ApiService.da_addressreport().subscribe((data) => {
      for (const prop in data) {
        this.customers.push(data[prop]);
      }
      console.log(data)
      this.tableshow = true
      this.spinner = false;
    });
  }
  public showSpinner(): void {
    // this.spinner = true;
    this.spinnerService.show();
  }

    private addPrintStyles() {
      const head = document.getElementsByTagName('body')[0];
      const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = `
        @media print {
          body * {
            visibility: hidden;
            //display: block;
            //display: none;
          }
          #table-to-print {
            visibility: visible;
          }
        }
      `;

      head.appendChild(style);
    }
}